import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { StatusShowInfoStyled } from "./styled";

const StatusShowInfo = ({ theme_standard, color, status }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <StatusShowInfoStyled className={customClass} color={color}>
      <div className="status_color" />
      <div className="status_text">{status}</div>
    </StatusShowInfoStyled>
  );
};

StatusShowInfo.propTypes = {};

export default StatusShowInfo;
